import React from 'react';
import Text from '@/components/Text/Text';
import styles from './TitleDescription.module.scss';

const TitleDescription = ({ data }: { data: { title: string, description: string } }) => (
  <section className={styles.titleDescription}>
    <Text
      tag='h2'
      className={styles.title}
    >
      {data.title}
    </Text>
    <div
      className={styles.messageText}
      dangerouslySetInnerHTML={{
        __html: data.description.replace(/\n/g, '<br/>'),
      }}
    />
  </section>
);

export default TitleDescription;
